import React from 'react';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Ahora entro al aula con todo listo.',
    author: 'Mariana López',
    role: 'Docente primaria'
  }, {
    quote: 'Me ahorró horas de planificación.',
    author: 'Laura Fernández',
    role: '3° grado'
  }, {
    quote: 'Mis alumnos participan mucho más.',
    author: 'Carolina Pérez',
    role: 'Ciencias Naturales'
  }, {
    quote: 'Es el recurso más completo que usé.',
    author: 'Silvia Gómez',
    role: 'Directora primaria'
  }];
  return <section className="bg-gray-50 py-10 px-4" data-id="element-199">
      <div className="max-w-3xl mx-auto" data-id="element-200">
        <h2 className="text-2xl md:text-3xl font-black text-center text-gray-900 mb-6 font-['Oswald'] uppercase" data-id="element-201">
          Lo que dicen otras docentes
        </h2>

        <div className="grid grid-cols-2 gap-3" data-id="element-202">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-4 rounded-lg shadow-md border-b-4 border-green-500" data-id="element-203">
              <div className="flex gap-0.5 text-yellow-400 mb-2" data-id="element-204">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" data-id="element-205" />)}
              </div>
              <p className="text-sm font-medium text-gray-800 mb-3 italic" data-id="element-206">
                "{t.quote}"
              </p>
              <div data-id="element-207">
                <p className="font-bold text-gray-900 text-sm" data-id="element-208">{t.author}</p>
                <p className="text-xs text-gray-500" data-id="element-209">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}